import type {State} from '../../../../reducers/types'
import type {BuildId, InexactCountable} from '../../../../types'
import {getBuildChangesIdsByBuildId} from '../Changes.selectors'

export const getIsReadyBuildChangesIdsByBuildId: (arg0: State, arg1: BuildId) => boolean = (
  state,
  buildId,
) => getBuildChangesIdsByBuildId(state, buildId) != null

export const getBuildArtifactDependenciesChangesCount: (
  state: State,
  buildId: BuildId,
) => InexactCountable | null | undefined = (state, buildId) =>
  state.changesDropdown.artifactDependencyChangesCount[buildId]
